export default {
  name: 'virtualgreyhoundraces',
  maxRacerNumber: 6,
};
